import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  className?: string
}

function Add({ className }: Props) {
  return (
    <IconBase name="add" w={24} className={className}>
      <path d="M12.1118 3.06445V21.1597" strokeWidth="2" fill="none"/>
      <path d="M21.1597 12.1118H3.06443" strokeWidth="2" fill="none"/>
    </IconBase>
  )
}

export default Add
